import React, { FC, useContext, useState } from 'react';
import Button from '@bankiru/ui-kit/core/Button';

import { ThemeContext } from '../../../../../context/ThemeContextWrapper';
import { useYandexMetric } from '../../../../../hooks/useYandexMetric';
import { ConsentKeys } from '../../../../../types/consents';
import { I18n } from '../../../../i18n';
import { getSocialButton } from '../../helpers';
import { SocialProvider } from '../../types';

type OtherSocialProvidersPanelProps = {
	providers: SocialProvider[];
	checkedConsents: Record<ConsentKeys, boolean>;
	isDisabled: boolean;
	i18n: I18n;
};

export const OtherSocialProvidersPanel: FC<OtherSocialProvidersPanelProps> = ({
	providers,
	checkedConsents,
	isDisabled,
	i18n,
}) => {
	const { trackYM } = useYandexMetric();
	const { platform } = useContext(ThemeContext);

	const [isExpanded, setExpanded] = useState(false);

	if (!providers.length) {
		return null;
	}

	if (isExpanded || providers.length === 1) {
		return (
			<>
				{providers.map(provider =>
					getSocialButton({
						provider,
						checkedConsents,
						trackYM,
						isDisabled,
						platform,
						isWithoutLabel: true,
					}),
				)}
			</>
		);
	}

	const getPluralPostfix = (count: number) => {
		if (count === 1) {
			return 'moreWays_one' as const;
		}

		if (count >= 2 && count <= 4) {
			return 'moreWays_two' as const;
		}

		return 'moreWays_five' as const;
	};

	return (
		<>
			<Button
				size="h48"
				skin="white"
				onClick={() => {
					setExpanded(true);
				}}
				isDisabled={isDisabled}
			>
				{i18n.msg(getPluralPostfix(providers.length), String(providers.length))}
			</Button>
		</>
	);
};
